import React from 'react';
import { createSvgIcon } from 'extended-oxygen-elements';

export default createSvgIcon(
  <>
    <path d='M0 0h24v24H0V0z' fill='none' />
    <path
      d='M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0
        16H5V9h14v10zM5 7V5h14v2H5zm2 4h10v2H7zm0 4h7v2H7z' />
  </>,
  'EventNotesIcon'
);
